import { ROUTES } from "pages/expenses/constants";
import { getRoute } from "pages/expenses/utils";

export const getSelectedAdminTab = (pathname: string) => {
  const route = getRoute(pathname);

  switch (route) {
    case ROUTES.ACTIVE_REQUESTS_LIST:
      return 0;
    case ROUTES.REQUEST_HISTORY:
      return 1;
    case ROUTES.SETTINGS:
      return 2;
    default:
      return 0;
  }
};
